import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { Button, Dropdown, Form, Table } from "react-bootstrap";
import {
  getBackSiteid,
  getThiscoCustomer,
  fetchThiscoCustomer,
  fetchThiscoAllCustomer,
  saveThiscoOtHour,
  submitThiscoOtHour,
  getSubmitButtonDetail,
} from "../../../modules/serverCall";
import moment from "moment";
import "./stylesheets/otHours.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import Spinner from "react-bootstrap/Spinner";
import { IoIosInformationCircle } from "react-icons/io";

const OtHours = () => {
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedTech, setSelectedTech] = useState("");
  const [siteId, setSiteId] = useState(null);
  const [techId, setTechId] = useState(null);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [submitBtn, setSubmitBtn] = useState(false);
  const [currentMonthData, setCurrentMonthData] = useState(new Date());
  const [listSiteId, setListSiteId] = useState([]);
  const [listTechId, setListTechId] = useState([]);
  const [allCustomers, setAllCustomers] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState();
  const [showTooltipBox, setShowTooltipBox] = useState(false);

  const handleMouseEnterFetch = () => {
    setShowTooltipBox(true);
  };

  const handleMouseLeaveFetch = () => {
    setShowTooltipBox(false);
  };

  const handleDropdownSite = (key, event) => {
    setSelectedSite(event.target.innerHTML);
    setSiteId(key);
    setCustomerDetails([]);
    setSubmitBtn(false);
    setAllCustomers(false);
  };

  const handleDropdownTech = (key, event) => {
    setSelectedTech(event.target.innerHTML);
    setTechId(key);
    setCustomerDetails([]);
  };

  const handleTimeChange = (event, index, field) => {
    const updatedData = [...customerDetails];
    updatedData[index][field] = event.target.value;

    const startTime = updatedData[index].StartTime;
    const endTime = updatedData[index].EndTime;
    const factor = updatedData[index].Factor;

    const totalHours = calculateTotalHours(startTime, endTime);
    updatedData[index].TotalHours = totalHours;

    updatedData[index].OTHours = calculateOTHours(totalHours, factor);

    setCustomerDetails(updatedData);
    setIsModified(true);
  };

  const handleFactorChange = (event, index) => {
    const updatedData = [...customerDetails];
    updatedData[index].Factor = event.target.value;

    const startTime = updatedData[index].StartTime;
    const endTime = updatedData[index].EndTime;

    const totalHours = calculateTotalHours(startTime, endTime);
    updatedData[index].OTHours = calculateOTHours(
      totalHours,
      updatedData[index].Factor
    );
    setCustomerDetails(updatedData);
    setIsModified(true);
  };

  const calculateOTHours = (totalHours, factor) => {
    if (totalHours > 9) {
      let totalDiff = totalHours - 9;

      // Round OT Hours to the nearest 0.5
      totalDiff = Math.round(totalDiff * 2) / 2;

      return totalDiff;
    } else {
      let otHour = 0;

      return otHour;
    }
  };

  const calculateTotalHours = (startTime, endTime) => {
    const start = moment(startTime, "HH:mm:ss");
    const end = moment(endTime, "HH:mm:ss");
    let duration = moment.duration(end.diff(start));
    let hours = duration.asHours();

    if (hours < 0) {
      hours += 24;
    }

    return hours;
  };

  const handleInputFetch = async () => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    setLoadingData(true);

    const sendData = {
      siteId: siteId,
      userId: userId,
      techId: techId,
      month: moment(currentMonthData).format("MM"),
      year: moment(currentMonthData).format("YYYY"),
    };

    const response = allCustomers
      ? await fetchThiscoAllCustomer(sendData)
      : await fetchThiscoCustomer(sendData);

    setCustomerDetails(response);
    setIsModified(false);
    setLoadingData(false);
  };

  const handleInputChange = (date) => {
    setCurrentMonthData(date);
    setCustomerDetails([]);
    setSubmitBtn(false);
  };

  const handleSave = async () => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    // Filter out the objects where StartTime and EndTime are not "00:00:00"
    const filteredDetails = customerDetails.filter(
      (item) => item.StartTime !== "00:00:00" && item.EndTime !== "00:00:00"
    );

    if (filteredDetails.length === 0) {
      console.log("No data to save.");
      return;
    }
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    const ApplicationTenantID = readDataSelected.ApplicationTenantID;

    // Prepare data for API request
    const sendData = {
      ModifiedBy: userId,
      TechnicianId: techId,
      ApplicationTenantID: ApplicationTenantID,
      ModifiedDate: moment(currentMonthData).format(),
      ThiscoOTHour: filteredDetails,
    };

    try {
      // API call (assuming you have an API function like saveCustomerDetails)
      const response = await saveThiscoOtHour(sendData);
      console.log("response", response);

      if (response.success) {
        console.log("Data saved successfully");
      } else {
        console.log("Error saving data:", response.message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const handleSubmit = async () => {
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);

    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    var submitData = {
      SiteId: siteId,

      Month: moment(currentMonthData).format("MM"),
      Year: moment(currentMonthData).format("YYYY"),
      Status:
        permissionsreadData[0].PermissionCode === "VALIDATE_JOB" ? 60 : 90,
      ModifiedBy: userId,
      TypeOfEntry: "SITEOT",
    };

    try {
      // API call (assuming you have an API function like saveCustomerDetails)
      const response = await submitThiscoOtHour(submitData);
      console.log("response", response);

      if (response.success) {
        console.log("Data saved successfully");
      } else {
        console.log("Error saving data:", response.message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    const fetchSiteId = async () => {
      const sendData = { userid: userId };
      const responsesites = await getBackSiteid(sendData);
      const siteIdArr = responsesites.map((site) => ({
        key: site.SiteID,
        value: site.SiteName,
      }));

      setListSiteId(siteIdArr);
      setSelectedSite(siteIdArr[0].value);
      setSiteId(siteIdArr[0].key);
    };

    fetchSiteId();
  }, []);

  useEffect(() => {
    if (siteId) {
      const fetchCustomerName = async () => {
        const sendData = {
          siteId: siteId,
          date: moment(currentMonthData).format("YYYY-MM-01"),
        };
        const responsesites = await getThiscoCustomer(sendData);
        const techNameIdArr = responsesites.map((site) => ({
          key: site.TechnicianID,
          value: site.TechnicianName,
        }));

        setListTechId(techNameIdArr);
        if (techNameIdArr.length > 0) {
          setSelectedTech(techNameIdArr[0].value);
          setTechId(techNameIdArr[0].key);
        }
      };

      fetchCustomerName();
    }
  }, [siteId, currentMonthData]);

  useEffect(() => {
    if (siteId) {
      const fetchSubmitButton = async () => {
        const sendData = {
          siteId: siteId,
          month: moment(currentMonthData).format("MM"),
          year: moment(currentMonthData).format("YYYY"),
        };

        const response = await getSubmitButtonDetail(sendData);
        setShowSubmitButton(response.ShowSubmit);

        console.log(response.ShowSubmit);
      };
      fetchSubmitButton();
    }
  }, [siteId, allCustomers]);

  const totalOTHours = customerDetails.reduce(
    (sum, row) => sum + (row.OTHours || 0),
    0
  );

  return (
    <div>
      <HeaderBack />
      <div className="container jobfilter mb-4 mt-4">
        <div className="headerfilter-inct">
          <div className="viewcalander">
            <DatePicker
              selected={currentMonthData}
              onChange={handleInputChange}
              dateFormat="MMM yyyy"
              showMonthYearPicker
              className="input-date-data-in outLine font_size"
            />
          </div>
          <div className="filterbtnsite">
            <Dropdown onSelect={handleDropdownSite}>
              <Dropdown.Toggle
                variant="warning"
                className="font_size"
                id="dropdown-basic"
              >
                {selectedSite}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {listSiteId.map((item) => (
                  <Dropdown.Item
                    className="font_size"
                    key={item.key}
                    eventKey={item.key}
                  >
                    {item.value}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="checkbox-all-customers">
            <Form.Check
              type="checkbox"
              label="Select All "
              id="checkbox-all-customers"
              checked={allCustomers}
              onChange={() => {
                setAllCustomers(!allCustomers);
                // setSelectedTech("");
                setCustomerDetails([]);
              }}
            />
          </div>
          {!allCustomers && (
            <div className="filterbtnsite">
              <Dropdown onSelect={handleDropdownTech} disabled={allCustomers}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-tech"
                >
                  {selectedTech || "Select Technician"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-scroll-dropdown">
                  {listTechId.map((item) => (
                    <Dropdown.Item
                      className="font_size"
                      key={item.key}
                      eventKey={item.key}
                    >
                      {item.value}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          <div className="filterbtn">
            <Button
              variant="primary"
              className="font_size"
              onClick={handleInputFetch}
            >
              Fetch
            </Button>
          </div>
          {allCustomers ? (
            showSubmitButton ? (
              <div className="filterbtn alignLeft">
                <Button
                  variant="warning"
                  className={`font_size ${
                    customerDetails.length >= 1 ? "" : "disabledBtn"
                  }`}
                  disabled={customerDetails.length >= 1 ? false : true}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            ) : null
          ) : (
            <div
              className="filterbtn alignLeft"
              style={{ position: "relative" }}
            >
              <Button
                variant="warning"
                // className={`font_size ${!isModified ? "disabledBtn" : ""}`}
                className={`font_size ${
                  customerDetails.length >= 1 ? "" : "disabledBtn"
                }`}
                onClick={handleSave}
                // disabled={!isModified}
                disabled={customerDetails.length >= 1 ? false : true}
              >
                Save
              </Button>
              <span className="pickbtn-note">
                <IoIosInformationCircle
                  size={20}
                  onMouseEnter={handleMouseEnterFetch}
                  onMouseLeave={handleMouseLeaveFetch}
                />
                {showTooltipBox && (
                  <div
                    style={{
                      position: "absolute",
                      top: "113%",
                      width: "250px",
                      transform: "translateX(-50%)",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      zIndex: 9999,
                    }}
                  >
                    <strong
                      style={{
                        color: "#a5e7a5",
                      }}
                    >
                      Green
                    </strong>{" "}
                    : Data is saved
                    <br />
                    <strong
                      style={{
                        color: "#f5eb8d",
                      }}
                    >
                      Yellow
                    </strong>{" "}
                    : Data is yet to be saved
                  </div>
                )}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="container">
        <div className={`${allCustomers ? "table-2" : "table-height"} `}>
          <Table bordered className="scrollable-table">
            <thead>
              {allCustomers ? (
                <tr
                  style={{
                    fontSize: "12px",
                    position: "sticky",
                    top: "0",
                    backgroundColor: "#C8C8C8",
                  }}
                >
                  <th>ID</th>
                  <th>Name</th>
                  <th>Days</th>
                  <th>OT Hours</th>
                  <th>Factored OT Hours</th>
                </tr>
              ) : (
                <tr
                  style={{
                    fontSize: "12px",
                    position: "sticky",
                    top: "0",
                    backgroundColor: "#C8C8C8",
                  }}
                >
                  <th>Date</th>
                  {/* <th>ID</th>
                  <th>Name</th> */}
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Factor</th>
                  <th>OT Hours</th>
                </tr>
              )}
            </thead>
            <tbody className="">
              {customerDetails.length > 0 ? (
                customerDetails.map((row, index) =>
                  allCustomers ? (
                    <tr
                      style={{
                        fontSize: "11px",
                      }}
                    >
                      {" "}
                      <td>{row.TechnicianId}</td>
                      <td>{row.TechnicianName}</td>
                      <td>{row.Days}</td>
                      <td>{row.OTHours}</td>
                      <td>{row.FactoredOTHours}</td>
                    </tr>
                  ) : (
                    <tr
                      key={row.TechnicianID}
                      style={{
                        backgroundColor:
                          row.Editable === "Y" && row.FlagSave === "Y"
                            ? "#f5eb8d"
                            : row.Editable === "Y" && row.FlagSave === "N"
                            ? "#a5e7a5"
                            : "", // Default color if none of the conditions are met
                        fontSize: "11px",
                      }}
                    >
                      <td>{moment(row.CalendarDate).format("DD")}</td>

                      {/* <td>{row.TechnicianID}</td>
                      <td>{row.TechnicianName}</td> */}
                      <td>
                        {row.Editable !== "N" ? (
                          <input
                            type="time"
                            value={
                              row.StartTime === "00:00:00"
                                ? ""
                                : moment(row.StartTime, "HH:mm:ss").format(
                                    "HH:mm"
                                  )
                            }
                            onChange={(e) =>
                              handleTimeChange(e, index, "StartTime")
                            }
                          />
                        ) : (
                          row.StartTime
                        )}
                      </td>
                      <td>
                        {row.Editable !== "N" ? (
                          <input
                            type="time"
                            value={
                              row.EndTime === "00:00:00"
                                ? ""
                                : moment(row.EndTime, "HH:mm:ss").format(
                                    "HH:mm"
                                  )
                            }
                            onChange={(e) =>
                              handleTimeChange(e, index, "EndTime")
                            }
                          />
                        ) : (
                          row.EndTime
                        )}
                      </td>
                      <td>
                        {row.Editable !== "N" ? (
                          <Form.Control
                            type="number"
                            className="font_size removePadding"
                            style={{
                              padding: "2px",
                            }}
                            value={row.Factor || ""}
                            onChange={(event) =>
                              handleFactorChange(event, index)
                            }
                            step="0.1"
                          />
                        ) : (
                          row.Factor
                        )}
                      </td>
                      <td>{row.OTHours}</td>
                    </tr>
                  )
                )
              ) : loadingData === true ? (
                <tr>
                  <td className="noData" colSpan={28}>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="noData" colSpan={28}>
                    no data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        {allCustomers ? null : (
          <div className="flexboxEnd">
            <p>Total OT Hours: {totalOTHours.toFixed(1)}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtHours;
